import { ListItemIcon } from '@mui/material';
import { TimelineListItem, TimelineListItemText } from '@procureai/ui-mui';
import { Trans } from 'react-i18next';

import { getMessage, levelMap } from '../BusinessLogItem.util';
import { TransCuriosityLookup } from '../TransCuriosityLookup/TransCuriosityLookup';
import { I18nNamespace } from '~/common/types';
import { Item } from '~/components/VirtualList/VirtualList';

export type BusinessLogItemProps = {
  item: Item;
  virtual?: boolean;
  secondary?: React.ReactNode;
  primary?: React.ReactNode;
};

export const BaseBusinessLogItem = ({ item, virtual, secondary, primary }: BusinessLogItemProps) => {
  const { id, template, status, context } = item;
  const { icon: StatusIcon, color: statusColor } = levelMap?.[status] ?? levelMap.NEUTRAL;
  const message = primary ?? (
    <Trans
      ns={I18nNamespace.businessLog}
      i18nKey={template}
      values={context}
      components={{
        lookup: <TransCuriosityLookup context={context} />,
      }}
    />
  );
  const noWrapIfVirtual = virtual ? { noWrap: true } : undefined;

  return (
    <TimelineListItem dense key={id}>
      <ListItemIcon>
        <StatusIcon color={statusColor} />
      </ListItemIcon>
      <TimelineListItemText
        primary={getMessage(virtual, message)}
        slotProps={{
          primary: noWrapIfVirtual,
          secondary: noWrapIfVirtual,
        }}
        secondary={secondary}
      />
    </TimelineListItem>
  );
};
